import { call, put, takeLatest } from "redux-saga/effects";
import { loginProps, permissionListProps } from "../../interfaces";
import {
  HANDLE_FETCH_AMADEUS_TOKEN,
  FETCH_USER_PERMISSIONS,
  HANDLE_LOGIN,
  HANDLE_LOGOUT,
  HANDLE_SEND_OTP,
  HANDLE_SUBMIT_OTP,
  HANDLE_CHANGE_PASSWORD,
} from "./types";
import {
  changePasswordService,
  fetchUserPermissionsService,
  getAmadeusTokenService,
  loginService,
  logoutService,
  sendOtpService,
  submitOtpService,
} from "../../services";
import { setAmadeusToken, setAuthUser, setUserPermission } from "./slice";
import { store } from "..";
import moment from "moment";
import { setAlert } from "../basicSlices";
import { disconnectPubNub } from "src/pubnub";

function* handleLogin({ payload }: { payload: loginProps }): Generator<any> {
  try {
    const responseData: any = yield call(loginService, payload);
    sessionStorage.setItem("IsSameSession", "Yes");
    yield put(setAuthUser({ ...responseData, isPersist: payload?.isPersist }));
  } catch (error: any) {
    yield put(
      setAlert({
        text: error?.message,
        type: "danger",
        title: "Failed to Login",
      })
    );
  }
}

function* handleSendOtp({ payload }: { payload: any }): Generator<any> {
  try {
    const responseData: any = yield call(sendOtpService, payload);
    return responseData;
  } catch (error: any) {
    yield put(
      setAlert({
        text: error?.message,
        type: "danger",
        title: "Failed to Send OTP",
      })
    );
  }
}

function* handleSubmitOtp({ payload }: { payload: any }): Generator<any> {
  try {
    const responseData: any = yield call(submitOtpService, payload);
    return responseData;
  } catch (error: any) {
    yield put(
      setAlert({
        text: error?.message,
        type: "danger",
        title: "Invalid OTP. Please try again.",
      })
    );
  }
}

function* handleChangePassword({ payload }: { payload: any }): Generator<any> {
  try {
    const responseData: any = yield call(changePasswordService, payload);
    return responseData;
  } catch (error: any) {
    yield put(
      setAlert({
        text: error?.message,
        type: "danger",
        title: "Failed to Send OTP",
      })
    );
  }
}

export function* handleFetchAmadeusToken(): Generator<any> {
  var token_time = store?.getState()?.authUser?.amadeus?.token_time;
  var expires_in = store?.getState()?.authUser?.amadeus?.expires_in;
  var token = store?.getState()?.authUser?.amadeus?.access_token;
  const end = moment();
  var duration = moment.duration(end.diff(moment(token_time)));
  var seconds = duration.asSeconds();
  if (seconds < parseInt(expires_in)) {
    return token;
  }
  try {
    const responseData: any = yield call(getAmadeusTokenService);
    yield put(setAmadeusToken({ ...responseData, token_time: new Date() }));
    token = responseData?.access_token;
  } catch (error) {}
  return token;
}

function* handleFetchUserPermissionList({
  payload,
}: {
  payload: permissionListProps;
}): Generator<any> {
  try {
    const responseData: any = yield call(fetchUserPermissionsService, payload);
    yield put(setUserPermission(responseData));
  } catch (error: any) {}
}

function* handleLogout({ payload }: { payload?: any }): Generator<any> {
  try {
    console.log("Starting logout saga...");

    // Immediately disconnect PubNub so user goes offline
    disconnectPubNub();

    // Call logout API service
    const responseData: any = yield call(logoutService, payload);

    console.log("Logout API completed:", {
      response: responseData,
      timestamp: new Date().toISOString(),
    });

    // Clear session data regardless of API response
    sessionStorage.removeItem("IsSameSession");
    localStorage.removeItem("deviceToken");
  } catch (error: any) {
    console.error("Logout saga error:", {
      error: error?.message || error,
      timestamp: new Date().toISOString(),
    });

    // Still clear local data even if API fails
    sessionStorage.removeItem("IsSameSession");
    localStorage.removeItem("deviceToken");
  }
}

export default function* authSaga() {
  yield takeLatest<any>(HANDLE_LOGIN, handleLogin);
  yield takeLatest<any>(HANDLE_LOGOUT, handleLogout);
  yield takeLatest<any>(HANDLE_SEND_OTP, handleSendOtp);
  yield takeLatest<any>(HANDLE_SUBMIT_OTP, handleSubmitOtp);
  yield takeLatest<any>(HANDLE_CHANGE_PASSWORD, handleChangePassword);
  yield takeLatest<any>(HANDLE_FETCH_AMADEUS_TOKEN, handleFetchAmadeusToken);
  yield takeLatest<any>(FETCH_USER_PERMISSIONS, handleFetchUserPermissionList);
}
